import React from 'react';
import { Container } from 'react-bootstrap';
import PropTypes from 'prop-types';
import PaymentCard from './components/PaymentCard';

const Payment = ({ amount, bookingid, onSubmit }) => (
  <Container>
    <PaymentCard amount={amount} bookingid={bookingid} onSubmit={onSubmit} />
  </Container>
);

Payment.propTypes = {
  amount: PropTypes.string.isRequired,
  bookingid: PropTypes.string.isRequired,
  onSubmit: PropTypes.func.isRequired,
};

export default Payment;
